module.exports = __webpack_public_path__ + "img/img_09.20d646d7.jpg";